import { createContext } from 'react';

export type FeatureFlagsType = {
  swipe: boolean;
  purchase: boolean;
  simpleSignup: boolean;
  purchaseAndSimpleSignup: boolean;
  requireEmailMarketingConstraint: boolean;
  minimumPurchaseAmount: boolean;
};

export const FeatureFlagContext = createContext<FeatureFlagsType>({
  swipe: false,
  purchase: false,
  simpleSignup: false,
  purchaseAndSimpleSignup: false,
  requireEmailMarketingConstraint: false,
  minimumPurchaseAmount: false,
});
